import { EntityModel } from '@/interfaces'
import {
  ALL_BACKGROUND_BLOCKS_QUERY,
  CREATE_BACKGROUND_BLOCK_MUTATION,
  DELETE_BACKGROUND_BLOCK_MUTATION,
  FORCE_DELETE_BACKGROUND_BLOCK_MUTATION,
  SINGLE_BACKGROUND_BLOCK_QUERY,
  UPDATE_BACKGROUND_BLOCK_MUTATION,
} from './graphql'
import cmsContentBlockAssignmentEntity from '@/entities/cmsContentBlockAssignment/entity'

const cmsBackgroundBlockModel: EntityModel = {
  name: 'backgroundBlock',
  namePlural: 'backgroundBlocks',
  uniqueName: 'cmsBackgroundBlock',
  uniqueNamePlural: 'cmsBackgroundBlocks',
  path: 'cms/blocks/background_block',
  baseUrl: '/cms/blocks/background_blocks',
  translationPrefix: 'entities:cmsBackgroundBlock.',
  getDisplayName: (values: any) => {
    return 'Background Block'
  },
  gql: {
    getAll: ALL_BACKGROUND_BLOCKS_QUERY,
    getSingle: SINGLE_BACKGROUND_BLOCK_QUERY,
    create: CREATE_BACKGROUND_BLOCK_MUTATION,
    update: UPDATE_BACKGROUND_BLOCK_MUTATION,
    delete: DELETE_BACKGROUND_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_BACKGROUND_BLOCK_MUTATION,
  },
  attributes: {
    backgroundVariant: {
      name: 'backgroundVariant',
      label: 'entities:cmsBackgroundBlock.attributes.backgroundVariant.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'primary',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:cmsBackgroundBlock.attributes.backgroundVariant.selectOptions.primary.label',
          value: 'primary',
        },
        {
          label: 'entities:cmsBackgroundBlock.attributes.backgroundVariant.selectOptions.secondary.label',
          value: 'secondary',
        },
        {
          label: 'entities:cmsBackgroundBlock.attributes.backgroundVariant.selectOptions.tertiary.label',
          value: 'tertiary',
        },
        {
          label: 'entities:cmsBackgroundBlock.attributes.backgroundVariant.selectOptions.quaternary.label',
          value: 'quaternary',
        },
        {
          label: 'entities:cmsBackgroundBlock.attributes.backgroundVariant.selectOptions.signal.label',
          value: 'signal',
        },
        {
          label: 'entities:cmsBackgroundBlock.attributes.backgroundVariant.selectOptions.theme.label',
          value: 'theme',
        },
      ],
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    contentBlockAssignments: {
      name: 'contentBlockAssignments',
      label: 'entities:cmsBackgroundBlock.attributes.contentBlockAssignments.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return cmsContentBlockAssignmentEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsBackgroundBlockModel
